import { css } from 'emotion';
import theme from '@lyearn-team/theme-config';

export const footerRoot = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${theme.color.dark.uranus};
  padding: 24px 90px;
  width: 100vw;
  .section {
    display: flex;
    flex-direction: column;
    button {
      margin-bottom: 2px;
    }
  }
  .previous {
    align-items: flex-start;
  }
  .next {
    align-items: flex-end;
  }
  @media (max-width: 767px) {
    padding: 28px 50px 28px 16px;
    .title {
      display: none;
    }
  }
`;
